import { createLocaleTextHook } from '@moonpig/web-core-locale-text'
import { AUTHENTICATION_WIZARD_TEXT } from './authWizard.locale'
import { SIGN_IN_WITH_CODE_BUTTON_TEXT } from '../components/AuthenticationWizard/SignInWithCode/SignInWithCodeButton/SignInWithCodeButton.locale'
import { SIGN_IN_WITH_CODE_FORM_TEXT } from '../components/AuthenticationWizard/SignInWithCode/SignInWithCodeForm/SignInWithCodeForm.locale'
import { ACCOUNT_LINK_WITH_CODE_FORM_TEXT } from '../components/SocialLoginOrchestrator/AccountLinkWithCodeForm.local'
import { SET_PASSWORD_TEXT } from '../components/AuthenticationWizard/SetPassword/SetPassword.locale'

export const useAuthenticationLocaleText = createLocaleTextHook({
  dictionary: {
    ...AUTHENTICATION_WIZARD_TEXT,
    ...SIGN_IN_WITH_CODE_BUTTON_TEXT,
    ...SIGN_IN_WITH_CODE_FORM_TEXT,
    ...ACCOUNT_LINK_WITH_CODE_FORM_TEXT,
    ...SET_PASSWORD_TEXT,
  },
})
